module.exports = __webpack_public_path__ + "static/media/mausam - heavy snow.eec00857.png";